<template>
  <div class="review col-xl-5 mt-4 mx-auto">
    <h5>Review the changes in this <b>NJCRIB ERM-14</b> Form</h5>
    <div role="tablist" class="mb-4">
      <b-card no-body v-for="(change, i) in changes" :key="change.changeID">
        <b-card-header header-tag="header" role="tab" class="p-0">          
          <b-button href="#" v-b-toggle="'accordion-' + i" variant="light" role="tabpanel" class="d-flex">
            <span class="accordion-collapsed"><i class="fas fa-chevron-circle-up fa-flip-vertical text-success"></i></span><span class="accordion-opened"><i class="fas fa-chevron-circle-up text-success"></i></span>
            <span class="button-text mx-auto">{{ changeTypeDescription(change.changeTypeID) }}</span>
          </b-button>
        </b-card-header>
        <b-collapse :id="`accordion-${i}`" accordion="submission-accordion" role="tabpanel">
          <b-card-body class="bg-light">
            <b-card-text>
              <div v-for="entity in entities.filter(e => e.changeID == change.changeID).sort((a, b) => a.beforeChange == b.beforeChange ? 0 : a.beforeChange ? -1 : 1)" :key="entity.entityID">
                <h5 class="mb-0">{{ entity.beforeChange ? 'Before' : 'After' }} - {{ entity.entityName }}</h5>
                <div class="address">{{ entity.address.address1 }}</div>
                <b-table-lite small bordered head-variant="light" :items="[officerDocument(entity.entityID)]" v-if="officerDocument(entity.entityID)" :fields="officerDocumentFields" class="mb-4">
                  <template v-slot:cell(formattedCreatedDate)="data">
                    {{ moment(data.item.created).format('MM/DD/YYYY') }}
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      size="sm"
                      download
                      @click="downloadOfficerDocument(data.item.documentID)"
                      variant="success">View</b-button>
                  </template>
                </b-table-lite>
                <b-table-lite v-else small bordered head-variant="light" :items="officers.filter(o => o.entityID == entity.entityID)" :fields="fields" class="mb-4">
                  <template v-slot:cell(officerType)="data">
                    {{ officerTypeDescription(data.item.officerTitleID) }}
                  </template>
                  <template v-slot:cell(interestAndType)="data">
                    {{ data.item.interest }}{{ data.item.interestType == 1 ? " shr." : '%' }}
                  </template>
                </b-table-lite>
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <b-button variant="success" @click="downloadERM14" :disabled="isDownloading">
      <span v-if="!isDownloading">Preview NJCRIB ERM-14 Form</span>
      <span v-else><b-spinner small></b-spinner> Downloading NJCRIB ERM-14...</span>
    </b-button>
    <b-alert show variant="danger" v-if="error" class="text-left mt-3">
      <p class="mb-0">Could not download the NJCRIB ERM-14 Form.</p>
    </b-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseService from '../services/BaseService.js'

export default {
  name: 'Review',
  data() {
    return {
      isDownloading: false,
      error: false,
      fields: [
        { key: 'officerName' , label: 'Officer Name' },
        { key: 'officerType' , label: 'Type' },
        { key: 'interestAndType' , label: 'Interest' }
      ],
      officerDocumentFields: [
        { key: 'fileName' , label: 'Officer List File Name', sortable: true, thStyle: { width: '30%' } },
        { key: 'formattedCreatedDate' , label: 'Created', sortable: true, thStyle: { width: '15%' } },
        { key: 'actions', label: '', sortable: false, class: ['action-buttons'] }
      ]
    }
  },
  methods: {
    downloadOfficerDocument(id) {
      this.error = false
      BaseService.getFileDownload(`/Document/${id}`).then(response => {
        this.DownloadFile(response)
      }).catch(() => {
        this.error = true
      })
    },
    officerDocument(id) {
      const o = this.officers.find(o => o.entityID == id && o.documentID)
      if (!o) return ''

      return this.documents.find(d => d.documentID == o.documentID)
    },
    downloadERM14() {
      this.error = false
      this.isDownloading = true
      BaseService.getFileDownload(`/Submission/Print/${this.submission.submissionID}`).then(response => {
        this.DownloadFile(response)
        this.isDownloading = false
      }).catch(() => {
        this.isDownloading = false
        this.error = true
      })
    },
    changeTypeDescription(id) {
      return this.changeTypes.find(c => c.changeTypeID == id).shortDescription
    },
    officerTypeDescription(id) {
      return this.officerTitles.find(o => o.officerTitleID == id).description
    },
    backClicked() {
      this.$router.push({
        name: 'change/list',
        params: {
          submissionId: this.submission.submissionID
        }
      })
    },
    nextClicked() {
      this.$router.push({
        name: 'certification',
        params: {
          submissionId: this.submission.submissionID
        }
      })
    }
  },
  computed: mapState({
    submission: state => state.submission.submission,
    changes: state => state.change.changes,
    entities: state => state.entity.entities,
    officers: state => state.officer.officers,
    changeTypes: state => state.application.changeTypes,
    officerTitles: state => state.application.officerTitles,
    documents: state => state.document.documents
  }),
  created() {
    this.$EventBus.$on('back-clicked', this.backClicked)
    this.$EventBus.$on('next-clicked', this.nextClicked)
  },
  beforeDestroy() {
    this.$EventBus.$off('back-clicked', this.backClicked)
    this.$EventBus.$off('next-clicked', this.nextClicked)
  }
}
</script>

<style scoped>
.card-text {
  color: black !important;
}

.button-text {
  position: relative;
}

.collapsed > .accordion-opened,
:not(.collapsed) > .accordion-collapsed {
  display: none !important;
}

.address {
  margin-top: -5px;
  color: gray;
  font-size: 14px;
  margin-bottom: -3px;
}
</style>